import React from "react";
import { WifiOff } from "lucide-react";
type OfflineBannerProps = {
  text?: string;
};
export function OfflineBanner({
  text = "আপনি বর্তমানে অফলাইনে আছেন"
}: OfflineBannerProps) {
  return <div className="flex items-center gap-2 rounded-xl border border-[#f0d69e] bg-[#fff8e8] px-3 py-2.5 text-xs font-semibold text-[#8a5a00]" data-id="element-153" data-mp="31l5bjgxqolhd"><WifiOff size={17} data-id="element-154" data-mp="36in9yde4rib4" /><span data-id="element-155" data-mp="36j6t1xfiocqq">{text}</span></div>;
}